module.exports = __webpack_public_path__ + "65df3d36caafe8d230250c56d5e90426.png";